import { JOURNEY_PARAMS, FOOTER_DATA, HOME_PAGE_CONTENT } from './constants';
import { IJOURNEY_PARAMS, IJOURNEY_FOOTER_PARAMS } from './validation';
export function updateJourneyParams(actionData: IJOURNEY_PARAMS['actionData']): IJOURNEY_PARAMS {
  return {
    type: JOURNEY_PARAMS,
    actionData,
  };
}
export function updateFooterData(actionData: IJOURNEY_FOOTER_PARAMS['actionData']): IJOURNEY_FOOTER_PARAMS {
  return {
    type: FOOTER_DATA,
    actionData,
  };
}
export function updateHomePageContent(actionData: any): any {
  return {
    type: HOME_PAGE_CONTENT,
    actionData,
  };
}
